<ng-container *appPlatformIf>
  <ng-container *ngIf="type === 'secondary'; else primary">
    <section [formGroup]="form" [ngClass]="settings" class="calculate">
      <div class="calculate-wrap">
        <div class="range">
          <div class="range-header d-flex align-items-center justify-content-between">
            <span class="range-label">{{ 'CALCULATE.AMOUNT' | translate }}</span>
            <span class="range-output text-right">{{ amount | formatNumber }} грн</span>
          </div>
          <div class="range-control">
            <div [class.range-trick_disable]="amountControl.disabled" [style.width.%]="25" class="range-trick">
              <span *ngIf="!amountControl.disabled" class="range-tooltip range-tooltip_amount">
                <span>{{ loan.amount }}</span><span>грн</span>
              </span>
            </div>
            <div [style.width.%]="75" class="range-slider d-flex">
              <ion-range
                (ionInput)="updateAmount($event.detail.value)"
                [class]="type"
                [max]="amountOptions.ceil"
                [min]="amountOptions.floor"
                [snaps]="amountOptions.snaps"
                [step]="amountOptions.step"
                [ticks]="false"
                [value]="amount"
                aria-label="Volume"
                formControlName="amount"
              />
            </div>
          </div>
        </div>
        <div class="range">
          <div class="range-header d-flex align-items-center justify-content-between">
            <span class="range-label">{{ 'CALCULATE.TERM' | translate }}</span>
            <span class="range-output text-right">{{ term }} {{ 'CALCULATE.DAYS' | translate }}</span>
          </div>
          <div class="range-control">
            <div [class.range-trick_disable]="termControl.disabled" [style.width.%]="45" class="range-trick">
              <span *ngIf="!termControl.disabled" class="range-tooltip range-tooltip_term">
                <span>{{ loan.term }}</span><span>{{ 'CALCULATE.DAYS' | translate }}</span>
              </span>
            </div>
            <div [style.width.%]="55" class="range-slider d-flex">
              <ion-range
                (ionInput)="updateTerm($event.detail.value)"
                [class.disabled-control]="termControl.disabled"
                [class]="type"
                [max]="termOptions.ceil"
                [min]="termOptions.floor"
                [snaps]="termOptions.snaps"
                [step]="termOptions.step"
                [ticks]="false"
                [value]="term"
                aria-label="Volume"
                formControlName="term"
              ></ion-range>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-template #primary>
    <section [formGroup]="form" [ngClass]="settings" class="calculate">
      <div class="calculate-wrap">
        <div class="range">
          <div class="range-header d-flex align-items-center justify-content-between">
            <span class="range-label">{{ 'CALCULATE.AMOUNT' | translate }}</span>
            <span class="range-output fw-semi-bold text-right">{{ amount }} грн</span>
          </div>
          <div class="range-control d-flex justify-content-between align-items-center">
            <button
              (click)="updateAmount(amount - 100)"
              [ngClass]="{'range-button__disabled': amountControl?.disabled}"
              class="range-button range-button_increment"
              type="button"
            ></button>
            <div class="range-slider d-flex">
              <ion-range
                (ionInput)="updateAmount($event.detail.value)"
                [class]="type"
                [max]="amountOptions.ceil"
                [min]="amountOptions.floor"
                [snaps]="amountOptions.snaps"
                [step]="amountOptions.step"
                [ticks]="false"
                [value]="amount"
                aria-label="Volume"
                formControlName="amount"
              />
            </div>
            <button
              (click)="updateAmount(amount + 100)"
              [ngClass]="{'range-button__disabled':
             amountControl?.disabled}"
              class="range-button range-button_decrement"
              type="button"
            ></button>
          </div>
          <div class="range-footer d-flex justify-content-between">
            <span>{{ 'CALCULATE.AMOUNT_FROM' | translate : {value: product?.minAmount} }}</span>
            <span>{{ 'CALCULATE.AMOUNT_TILL' | translate : {value: product?.maxAmount} }}</span>
          </div>
        </div>
        <div class="range">
          <div class="range-header d-flex align-items-center justify-content-between">
            <span class="range-label">{{ 'CALCULATE.TERM' | translate }}</span>
            <span class="range-output fw-semi-bold text-right">{{ term }} {{ 'CALCULATE.DAYS' | translate }}</span>
          </div>
          <div class="range-control d-flex justify-content-between align-items-center">
            <button
              (click)="updateTerm(term - product!.termStep)"
              [ngClass]="{'range-button__disabled': termControl?.disabled}"
              class="range-button range-button_increment"
              type="button"
            ></button>
            <div class="range-slider d-flex">
              <ion-range
                (ionInput)="updateTerm($event.detail.value)"
                [class.disabled-control]="termControl.disabled"
                [class]="type"
                [max]="termOptions.ceil"
                [min]="termOptions.floor"
                [snaps]="termOptions.snaps"
                [step]="termOptions.step"
                [ticks]="false"
                [value]="term"
                aria-label="Volume"
                formControlName="term"
              ></ion-range>
            </div>
            <button
              (click)="updateTerm(term + product!.termStep)"
              [ngClass]="{'range-button__disabled': termControl?.disabled}"
              class="range-button range-button_decrement"
              type="button"
            ></button>
          </div>
          <div class="range-footer d-flex justify-content-between">
            <span>{{ 'CALCULATE.TERM_FROM' | translate : {value: product?.minTerm} }}</span>
            <span>{{ 'CALCULATE.TERM_TILL' | translate : {value: product?.maxTerm} }}</span>
          </div>
        </div>
      </div>
    </section>
  </ng-template>
</ng-container>
